export default __webpack_public_path__ + "static/media/helicopter.92b6c80d.svg";